import { CareerId } from '../../catalog/career';

export const CAREER_IDS_WITH_TRAINING: CareerId[] = [];
